module.exports = __webpack_public_path__ + "img/shopify-sm.6fa95c14.png";